














































































































































































































import { Component, Mixins } from 'vue-property-decorator';
import { mapGetters } from 'vuex';
import DatePicker from '@/components/shared/admin/Input/DatePicker.vue';
import moment from 'moment';
import NotifyMethods from '@/mixins/NotifyMethods.vue';

import { Actions, Mutations } from '@/ts/store/Constants';
import DateMethods from '@/mixins/DateMethods.vue';
import DatePickersMethods from '@/mixins/DatePickersMethods.vue';
import LocalizationMethods from '@/mixins/LocalizationMethods.vue';
import FlexibleTable from '@/components/Tables/FlexibleTable.vue';
import OverlayAddition from '@/components/Overlays/OverlayAddition.vue';
import PreviewEmailButton from '@/components/Admin/Layout/PreviewEmailButton.vue';
import { dateFormat, dateTimeFormat } from '@/ts/DefaultTableConfigs';
import { TableViewConfig } from '@/ts/interfaces/TableConfigTypes';

@Component({
    components: {
        DatePicker,
        FlexibleTable,
        OverlayAddition,
        PreviewEmailButton,
    },
    computed: {
        ...mapGetters({
            currentVacantUnitAdd: 'PresentationFlows/getCurrentVacantUnitAdd',
            applicationsForPresentation: 'PresentationFlows/getApplicationsForPresentation',
        }),
    },
})
export default class AddPresentation extends Mixins(DateMethods, DatePickersMethods, LocalizationMethods, NotifyMethods) {
    public messageToApplicants: string = '';
    public offerDeadlineDate: string = '';
    public offerMoveinDate: string = '';
    public offerPresentationDate: string = '';
    public nopresentationCheckbox: boolean = true;
    public notActiveInOtherOffers: boolean = true;
    public previouslyOfferedUnit: boolean = false;
    public smsNotification: boolean = false;

    public datePickers: string[] = [
        'presentation',
        'movein',
        'deadline',
    ];

    public defaultTableConfig: TableViewConfig = {
        visibleColumns: [
            'id',
            'createdAt',
            'interestedFrom',
            'name',
            'email',
            'phone',
            'language',
            'priority',
        ],
    };

    public dialogHeight: number = 0;
    public selectedApplication: any = [];

    constructor() {
        super();
    }

    get columns(): any {
        return [
            { name: 'id', label: this.$t('general.id', 'ID'), align: 'left', field: 'id', sortable: true, required: true },
            { name: 'createdAt', label: this.$t('general.application-date', 'Application date'), align: 'left', field: 'createdAt', sortable: true, filterType: 'date', dateFormat: dateTimeFormat,
                sort: (a: any, b: any) => {
                    const aTimestamp = a !== '' ? moment(a, dateTimeFormat).valueOf() : 0;
                    const bTimestamp = b !== '' ? moment(b, dateTimeFormat).valueOf() : 0;

                    return aTimestamp - bTimestamp;
                },
            },
            { name: 'interestedFrom', label: this.$t('general.application-interest-from', 'Interest from'), align: 'left', field: 'interestedFrom', sortable: true, filterType: 'date', dateFormat },
            { name: 'name', label: this.$t('general.name', 'Name'), align: 'left', field: 'name', sortable: true },
            { name: 'email', label: this.$t('general.email', 'E-mail'), align: 'left', field: 'email', sortable: true },
            { name: 'phone', label: this.$t('general.phone', 'Phone') , align: 'left', field: 'phone', sortable: true },
            { name: 'language', label: this.$t('general.language', 'Language') , align: 'left', field: 'language', sortable: true },
            { name: 'priority', label: this.$t('general.priority', 'Priority') , align: 'left', field: 'priority', sortable: true },
            { name: 'gender', label: this.$t('general.gender', 'Gender') , align: 'left', field: 'gender', sortable: true },
            { name: 'age', label: this.$t('general.age', 'Age') , align: 'left', field: 'age', sortable: true },
            { name: 'nationality', label: this.$t('general.origin', 'Origin') , align: 'left', field: 'nationality', sortable: true },
            { name: 'applicationMotivation', label: this.$t('general.application-motivation', 'Application motivation') , align: 'left', field: 'applicationMotivation', sortable: true },
            { name: 'aboutMe', label: this.$t('general.about-me', 'About me') , align: 'left', field: 'aboutMe', sortable: true },
            { name: 'educationTags', label: this.$t('general.education', 'Education') , align: 'left', field: 'educationTags', sortable: true, filterType: 'array' },
            { name: 'interestsTags', label: this.$t('general.interests', 'Interests') , align: 'left', field: 'interestsTags', sortable: true, filterType: 'array' },
            { name: 'minSize', label: this.$t('general.min_apartment_size', 'Min.size (m²)') , align: 'left', field: 'minSize', sortable: true, filterType: 'max-value-optional' },
            { name: 'maxSize', label: this.$t('general.max_apartment_size', 'Max. size (m²)') , align: 'left', field: 'maxSize', sortable: true, filterType: 'min-value-optional' },
            { name: 'minRent', label: this.$t('general.min_rent', 'Min. rent') , align: 'left', field: 'minRent', sortable: true, filterType: 'max-value-optional' },
            { name: 'maxRent', label: this.$t('general.max_rent', 'Max. rent') , align: 'left', field: 'maxRent', sortable: true, filterType: 'min-value-optional' },
            { name: 'numberOfRooms', label: this.$t('general.number_of_rooms', 'Number of rooms') , align: 'left', field: 'numberOfRooms', sortable: true },
            { name: 'optionAnswers', label: this.$t('general.zones', 'Zones') , align: 'left', field: 'optionAnswers', sortable: true, filterType: 'array'},
        ]; 
    }

    get chartsVisibility(): boolean {
        return this.$store.getters['UnitGroupingCharts/getTenantsDemographicFlayOutVisibility'];
    }

    get selectedUnit() {
        return this.$store.getters['PresentationFlows/getCurrentVacantUnitAdd'];
    }

    get deadlineDate() {
        return this.offerDeadlineDate;
    }

    set deadlineDate(value: string | null) {
        this.offerDeadlineDate = value;
    }

    get moveinDate() {
        return this.offerMoveinDate;
    }

    set moveinDate(value: string | null) {
        this.offerMoveinDate = value;
    }

    get presentationDate() {
        return this.offerPresentationDate;
    }

    set presentationDate(value: string | null) {
        this.offerPresentationDate = value;
    }

    get corporation() {
        return this.$store.getters['Corporations/getCorporation'](this.$store.getters['User/getCorporationId']);
    }

    public loadPreviewEmailOverlay(templateId: any ) {
        if (this.selectedApplication.length === 0) {
            return this.notify('at_least_one_applicant_should_be_selected', 'warning');
        }

        const data = {
            templateId,
            message: this.messageToApplicants,
            checkedIds: this.selectedApplication,
            noPresentation : this.nopresentationCheckbox,
            presentationDate: this.presentationDate,
            moveinDate: this.moveinDate,
            deadlineDate: this.deadlineDate,
            unitId: this.$store.getters['PresentationFlows/getCurrentVacantUnitAdd'].propertyId,
        };
        this.$store.dispatch(Actions.FETCH_TEMPLATE_RENDERER, data);
    }

    public calculateHeight() {
        this.dialogHeight = (this.$refs.dialogMainContainer as HTMLElement).offsetHeight;
    }

    public sendPresentationOffer()  {
        if ((!this.nopresentationCheckbox && this.presentationDate === '') || this.deadlineDate === '') {
            return this.notify(
                this.nopresentationCheckbox
                    ? 'deadline_date_is_required'
                    : 'deadline_and_presentation_dates_are_required',
                'warning',
            );
        }

        if (new Date().getTime() > new Date(this.deadlineDate).getTime() || (!this.nopresentationCheckbox && new Date().getTime() > new Date(this.presentationDate).getTime())) {
            return this.notify(
                this.nopresentationCheckbox
                    ? 'deadline_date_should_be_later_then_today'
                    : 'deadline_and_presentation_dates_should_be_later_then_today',
                'warning',
            );
        }

        if (this.selectedApplication.length === 0) {
            return this.notify('at_least_one_applicant_should_be_selected', 'warning');
        }

        this.$store.dispatch(Actions.SEND_PRESENTATION_OFFER, {
            message: this.messageToApplicants,
            checkedIds: this.selectedApplication,
            noPresentation : this.nopresentationCheckbox,
            presentationDate: this.presentationDate,
            moveinDate: this.moveinDate,
            deadlineDate: this.deadlineDate,
            smsNotification: this.smsNotification,
            unitId: this.$store.getters['PresentationFlows/getCurrentVacantUnitAdd'].propertyId,
        });
    }

    public cancel() {
        this.$store.commit(Mutations.SET_ADD_PRESENTATION_VISIBILITY, false);
        this.$store.commit(Mutations.SET_APPLICATION_MATCH, true);
    }

    public toggleNotActiveInOtherOffers() {
        this.$store.commit(Mutations.SET_NOT_ACTIVE_IN_OTHER_OFFERS, this.notActiveInOtherOffers);

        this.$store.dispatch(Actions.FETCH_APPLICATIONS_FOR_PRESENTATION, {
            unitId: this.$store.getters['PresentationFlows/getCurrentVacantUnitAdd'].propertyId,
            match: this.$store.getters['PresentationFlows/getMatchApplications'],
            project: this.$store.getters['PresentationFlows/getCurrentProject'],
            notActive: this.$store.getters['PresentationFlows/getNotActiveInOtherOffers'],
            previouslyOffered: this.$store.getters['PresentationFlows/getPreviouslyOfferedUnit'],
        });
    }

    public togglePreviouslyOffer() {
        this.$store.commit(Mutations.SET_PREVIOUSLY_OFFER_UNIT, this.previouslyOfferedUnit);

        this.$store.dispatch(Actions.FETCH_APPLICATIONS_FOR_PRESENTATION, {
            unitId: this.$store.getters['PresentationFlows/getCurrentVacantUnitAdd'].propertyId,
            match: this.$store.getters['PresentationFlows/getMatchApplications'],
            project: this.$store.getters['PresentationFlows/getCurrentProject'],
            notActive: this.$store.getters['PresentationFlows/getNotActiveInOtherOffers'],
            previouslyOffered: this.$store.getters['PresentationFlows/getPreviouslyOfferedUnit'],
        });
    }

    public toggleMatchApplications() {
        this.$store.commit(Mutations.SET_APPLICATION_MATCH);

        this.$store.dispatch(Actions.FETCH_APPLICATIONS_FOR_PRESENTATION, {
            unitId: this.$store.getters['PresentationFlows/getCurrentVacantUnitAdd'].propertyId,
            match: this.$store.getters['PresentationFlows/getMatchApplications'],
            project: this.$store.getters['PresentationFlows/getCurrentProject'],
            notActive: this.$store.getters['PresentationFlows/getNotActiveInOtherOffers'],
            previouslyOffered: this.$store.getters['PresentationFlows/getPreviouslyOfferedUnit'],
        });
    }

    public selectApplicants(selectedItems: any) {
        this.selectedApplication = selectedItems.map((item: any) => item.id);
    }

    public openCharts() {
        if (this.chartsVisibility) {
            this.resetCharts();
        } else {
            this.calculateHeight();

            this.$store.dispatch(Actions.FETCH_UNIT_GROUPINGS, this.$store.getters['PresentationFlows/getCurrentVacantUnitAdd'].propertyId);
        }
    }

    public resetCharts() {
        this.$store.commit(Mutations.RESET_UNIT_GROUPINGS);
        this.$store.commit(Mutations.SET_TENANTS_DEMOGRAPHIC_FLAYOUT_VISIBILITY, false);
        this.dialogHeight = 0;
    }

    public created() {
        if (typeof this.selectedUnit.releaseDate !== 'undefined' && this.selectedUnit.releaseDate !== null) {
            this.offerMoveinDate = this.selectedUnit.releaseDate;
        }

        this.offerDeadlineDate = moment.utc().add(5, 'days').format('YYYY-MM-DD');
    }

    public mounted() {
        window.addEventListener('resize', this.calculateHeight);
    }

    public destroyed() {
        window.removeEventListener('resize', this.calculateHeight);
        this.resetCharts();
    }
}
